import React, { useState, useEffect, useRef } from 'react';
import LoadingIndicator from '../../../common/loading_indicator.jsx';
import NoDataComponent from '../../no_data_component.jsx';
import * as d3 from 'd3';
import { useSelector } from 'react-redux';
import { useBaseWidget } from '../../hooks/useBaseWidget.jsx';
import { cloneDeep } from 'lodash';
import { datasetsConfigured, useDataset } from '../../hooks/useDataset.js';

function ValuesAchievedDatasetWidget({ widgetId, editing }) {
    const { formatNumber, numberWithUnit } = useBaseWidget();
    const { data, getCommonNumberUnit } = useDataset({widgetId});
    const settings = useSelector(state => state.dashboard.widgets[widgetId].settings) || {};
    const layout = useSelector(state => state.dashboard.layout[widgetId]);
    const [chartData, setChartData] = useState([]);
    const [noData, setNoData] = useState(true);
    const [loading, setLoading] = useState(false);
    const commonUnit = getCommonNumberUnit();
    const totalValueHidden = settings.show_total_value === 'false';
    const contentRef = useRef();

    const initChart = () => {
        if (contentRef.current) {
            let currentDatasets = settings.datasets;
            if (chartData.length > 0){
                currentDatasets = chartData
            }
            ValuesAchieved.init(contentRef.current, currentDatasets, commonUnit, settings)
        }
    }

    const formatData = () => {
        const datasets  = cloneDeep(settings.datasets) || [];
        let notConfigured = !( datasetsConfigured(datasets) || datasets.some((d) => d.value != ""))

        datasets.forEach((d, i) => {
            var endAngle = -0.5*Math.PI + (d.value/datasets[0].value)*Math.PI;
            var progress = (d.value/datasets[0].value);
            var value = (((data || {})[d.dataset_id] || [])[0] || {}).data || d.value
            d.endAngle = endAngle;
            d.progress = progress;
            d.value = value;
            d.displayedValue = formatNumber(numberWithUnit(value, commonUnit), commonUnit, d.number_precision, settings.number_format);
        });

        return {
            notConfigured: notConfigured,
            datasets: datasets
        };
    };

    const dataLoaded = () => {
        const data = formatData();
        if (data.notConfigured) {
            setNoData(true);
            setLoading(false);
        } else {
            setChartData(data.datasets);
            setLoading(false);
            setNoData(false);
        }
    }

    useEffect(() => {
        dataLoaded();
    }, [settings])
    
    useEffect(() => {
        initChart();
    }, [chartData, layout, editing])
    // style={{ width: dimensions.width, height: dimensions.height }}
    return (
        loading ? <LoadingIndicator /> : 
        (
            noData ? <NoDataComponent /> :
                <div className="section-values-achieved" ref={contentRef} style={{width: '100%', height: '100%'}}>
                    <div className="values-achieved-chart">
                        <div className={`values-info ${totalValueHidden ? 'hidden' : ''}`}>
                        <span className="value"></span>
                        <span className="value-progress"></span>
                        </div>
                        <div className={`values-total-info ${totalValueHidden ? 'hidden' : ''}`}>
                        <span className="total-value"></span>
                        <span className="total-text">{I18n.t('total')}</span>
                        </div>
                    </div>
                </div>
        )
    )
}

const ValuesAchieved = {
    init: function (widgetContainer, data, unit, settings){
        d3.select(widgetContainer).select('svg').remove();
  
        var width = widgetContainer.getBoundingClientRect().width - 20;
        var height = (jQuery(widgetContainer).height() - jQuery(widgetContainer).find('.widget-header').outerHeight()) - 10;
        var count = data.length;
        var donutWidth = (height*0.25 / count) - 2;
        var radius = (Math.min(width, height) / 2);

        let display_idx = settings.datasets.findIndex((ds) => !!settings.main_value_ds && ds.id === settings.main_value_ds);
        display_idx = display_idx < 0 ? 0 : display_idx;
        const display_progress = (data[display_idx].progress*100).toFixed(0);

        jQuery(widgetContainer).find('.values-info').css('visibility', 'hidden');
        jQuery(widgetContainer).find('.values-total-info').css({'color': data[display_idx].background_color, 'font-size': radius/12});
        jQuery(widgetContainer).find('.total-value').text(data[display_idx].displayedValue).css('font-size', radius/6);
        jQuery(widgetContainer).find('.total-text').text(display_progress < 100 ? display_progress + "% of total" : "Total");
        jQuery(widgetContainer).find('.values-total-info').css({'bottom': radius * 0.25, 'color': data[display_idx].background_color, 'height': radius * 0.4, 'width': radius * 0.8});

        var svg = d3.select(widgetContainer).select('.values-achieved-chart')
        .append('svg')
        .attr('width', width)
        .attr('height', height);
        data.map((ds, index) => {
          var radiusds = radius - index*(donutWidth+2)
          var svg1 = svg.append('g')
            .attr('transform', 'translate(' + (width / 2) + 
              ',' + (height / 2) + ')');
          var arc = d3.arc()
            .startAngle(-0.5*Math.PI)
            .endAngle(ds.endAngle)
            .innerRadius(radiusds - donutWidth)  
            .outerRadius(radiusds)
            .cornerRadius(10);

          var pie = d3.pie()
            .value(function(ds) { return ds.value; })
            .sort(null);
  
          var path = svg1.selectAll('path')
            .data(pie([ds]))
            .enter()
            .append('path')
            .attr('d', arc)
            .attr('fill', ds.background_color)
            .on('mouseover', function(){
                d3.select(this).style("opacity", 0.9);
                jQuery(widgetContainer).find('.values-info').css('visibility', '')
                jQuery(widgetContainer).find('.values-total-info').css('visibility', 'hidden')
                jQuery(widgetContainer).find('.value').text(ds.displayedValue).css('font-size', radius/6);
                jQuery(widgetContainer).find('.value-progress').text((ds.progress*100).toFixed(0) + "% of total").css('font-size', radius/12);;
                jQuery(widgetContainer).find('.values-info').css({'bottom': radius * 0.25, 'color': ds.background_color, 'height': radius * 0.4, 'width': radius * 0.8});
            })
            .on('mouseleave', function(){
              d3.select(this).style("opacity", 1);
                jQuery(widgetContainer).find('.values-info').css('visibility', 'hidden')
                jQuery(widgetContainer).find('.values-total-info').css('visibility', '')
            });

          svg1.append("text")
          .attr("transform", function(d){
            return "translate(" + (-radiusds + donutWidth*3/4 - (unit ? donutWidth*0.35 : 0)) + ", "+ donutWidth*0.3 + ") rotate(-90)";
          })
          .attr("text-anchor", "end")
          .style("font-size", unit ? donutWidth*0.4 : donutWidth*0.7 )
          .style("fill", settings.legend_text_color || ds.background_color)
          .text( function(d, i) {
            // With unit, split to two lines
            if (unit) {
              return (ds.displayedValue?.split(' ') || [])[0];
            }
            return ds.displayedValue;}
          )

          // When unit used. Add it on a separate line
          svg1.append("text")
          .attr("transform", function(d){
            return "translate(" + (-radiusds + donutWidth*3/4) + ", "+ donutWidth*0.3 + ") rotate(-90)";
          })           
          .attr("text-anchor", "end")
          .style("font-size", donutWidth*0.4 )
          .style("fill", settings.legend_text_color || ds.background_color)
          .text( function(d, i) {
            if (unit) {
              return (ds.displayedValue?.split(' ') || [])[1];
            }
            return '';
          });
            
            // .transition().duration(500)
            // .attrTween('d', function(d) {
            //   var i = d3.interpolate(d.startAngle+0.1, d.endAngle);
            //   return function(t) {
            //     d.endAngle = i(t);
            //     return arc(d);
            //   }
            // });
        })

        var legendItemSize = donutWidth*0.7;
        var legendSpacing = 5;
        var xOffset = width*2/3;
        var yOffset = height/2 + donutWidth*0.9;
        var legend = svg
        .selectAll('.legendItem')
        .data(data);
        
        //Create legend items
        legend
        .enter()
        .append('circle')
        .attr('class', 'legendItem')
        .attr('r', legendItemSize/2)
        .style('fill', d => d.background_color)
        .attr('transform',
        (d, i) => {
            var x = xOffset;
            var y = yOffset + (legendItemSize + legendSpacing) * i;
            return `translate(${x}, ${y})`;
        });
        
        //Create legend labels
        legend
        .enter()
        .append('text')
        .style("fill", d => settings.legend_text_color || d.background_color)
        .style("font-size", Math.min(donutWidth*0.4, 16))
        .attr('x', xOffset + legendItemSize + 5)
        .attr('y', (d, i) => yOffset+ legendItemSize/4 + (legendItemSize + legendSpacing) * i)
        .text(d => d.name_item);  
    },
};

export default ValuesAchievedDatasetWidget;
